import { SxProps, Theme } from "@mui/material";

export const screenContainerStyles: SxProps<Theme> = (theme: Theme) => ({
  position: "relative",
  width: "100%",
  height: "100dvh",
  background: theme.palette.liveSpeechScreen.background,
});

export const botInfoContainerStyles: SxProps = {
  position: "absolute",
  top: "30%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  display: "flex",
  flexDirection: "column",
  gap: "5px",
  alignItems: "center",

  "@media (min-height: 600px)": {
    top: "50%",
  },
};

export const botAvatarStyles: SxProps<Theme> = (theme: Theme) => ({
  width: 250,
  height: 250,
  borderRadius: "50%",
  maxWidth: "none",
  objectFit: "cover",
  objectPosition: "top",

  [theme.breakpoints.down("sm")]: {
    marginBottom: "50px",
  },
});

export const instructionAvatarStyles: SxProps<Theme> = (theme: Theme) => ({
  width: 250,
  height: 250,
  borderRadius: "50%",
  marginBottom: "20px",
  objectFit: "cover",
  objectPosition: "top",
  border:
    theme.palette.mode === "dark"
      ? "3px solid rgba(255, 255, 255, 0.3)"
      : "3px solid rgba(0, 0, 0, 0.2)",
  boxShadow:
    theme.palette.mode === "dark"
      ? "0 4px 20px rgba(255, 255, 255, 0.1)"
      : "0 4px 20px rgba(0, 0, 0, 0.1)",
});

export const liveSpeechInfoStyles: SxProps<Theme> = (theme: Theme) => ({
  textAlign: "center",
  color:
    theme.palette.mode === "dark"
      ? theme.palette.common.white
      : theme.palette.common.black,

  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
});

export const liveSpeechStepsInfoStyles: SxProps<Theme> = (theme: Theme) => ({
  textAlign: "center",
  fontWeight: "bold",
  color: "#d32f2f",
});

export const bottomPanelStyles: SxProps<Theme> = (theme: Theme) => ({
  position: "absolute",
  bottom: "3rem",
  left: "50%",
  transform: "translate(-50%, 0)",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: "2rem",

  [theme.breakpoints.down("sm")]: {
    gap: "2.5rem",
  },
});

export const hintStyles: SxProps<Theme> = (theme: Theme) => ({
  fontFamily: "Red Hat Display",
  fontSize: "14px",
  textAlign: "center",
  color:
    theme.palette.mode === "dark"
      ? theme.palette.common.white
      : theme.palette.common.black,

  [theme.breakpoints.down("sm")]: {
    width: "90vw",
  },
});

export const buttonsContainerStyles: SxProps = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "2rem",
};

export const startButtonStyles: SxProps = {
  borderRadius: "15px",
  backgroundColor: "rgb(59, 130, 246)",
  height: "50px",
  textWrap: "nowrap",
  textAlign: "center",

  "&:hover": {
    backgroundColor: "rgba(59, 130, 246, 0.8)",
  },
};

export const greenIconButtonStyles: SxProps<Theme> = (theme: Theme) => ({
  width: "50px",
  height: "50px",
  borderRadius: "50%",
  backgroundColor: "rgb(102, 239, 100)",
  color: "white",

  "&:hover": {
    backgroundColor: "rgba(102, 239, 100, 0.8)",
  },
});

export const redIconButtonStyles: SxProps<Theme> = (theme: Theme) => ({
  width: "50px",
  height: "50px",
  borderRadius: "50%",
  backgroundColor: "rgb(255, 121, 97)",
  color: "white",

  "&:hover": {
    backgroundColor: "rgba(255, 121, 97, 0.8)",
  },
});

export const stopIconButtonStyles: SxProps<Theme> = (theme: Theme) => ({
  width: "50px",
  height: "50px",
  borderRadius: "50%",
  backgroundColor: "rgb(178, 40, 15)",

  "&:hover": {
    backgroundColor: "rgba(178, 40, 15, 0.8)",
  },
});

export const microphoneTipStyles: SxProps = {
  "& .MuiPaper-root": {
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    padding: "10px 20px",
  },
};

export const microphoneTipTextStyles: SxProps = {
  color: "white",
  fontSize: "14px",
};

export const countdownContainerStyles: SxProps = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "20px",
  zIndex: 1000,
};

export const countdownNumberStyles: SxProps<Theme> = (theme: Theme) => ({
  fontSize: "120px",
  fontWeight: "bold",
  color: theme.palette.primary.main,
  textShadow: "0 0 20px rgba(25, 118, 210, 0.5)",
  animation: "pulse 0.5s ease-in-out",
  "@keyframes pulse": {
    "0%": {
      transform: "scale(1)",
      opacity: 1,
    },
    "50%": {
      transform: "scale(1.2)",
      opacity: 0.8,
    },
    "100%": {
      transform: "scale(1)",
      opacity: 1,
    },
  },
});

export const countdownStartStyles: SxProps<Theme> = (theme: Theme) => ({
  fontSize: "80px",
  fontWeight: "bold",
  color: theme.palette.success.main,
  textShadow: "0 0 20px rgba(76, 175, 80, 0.5)",
  animation: "startPulse 1s ease-in-out",
  "@keyframes startPulse": {
    "0%": {
      transform: "scale(1)",
      opacity: 1,
    },
    "50%": {
      transform: "scale(1.3)",
      opacity: 0.9,
    },
    "100%": {
      transform: "scale(1)",
      opacity: 1,
    },
  },
});

export const countdownOverlayStyles: SxProps = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0, 0, 0, 0.7)",
  zIndex: 999,
};

export const circularTimerContainerStyles: SxProps = {
  position: "absolute",
  top: "20px",
  right: "20px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  zIndex: 1000,
};

export const circularTimerStyles: SxProps = {
  position: "relative",
  width: "100px",
  height: "100px",
};

export const circularTimerTextStyles: SxProps<Theme> = (theme: Theme) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  fontSize: "18px",
  fontWeight: "bold",
  color:
    theme.palette.mode === "dark"
      ? theme.palette.common.white
      : theme.palette.common.black,
});

export const timerLabelStyles: SxProps<Theme> = (theme: Theme) => ({
  fontSize: "12px",
  fontWeight: "600",
  marginTop: "4px",
  marginBottom: "50px",
  textAlign: "center",
  color:
    theme.palette.mode === "dark"
      ? theme.palette.common.white
      : theme.palette.common.black,
});

export const headerContainerStyles: SxProps<Theme> = (theme: Theme) => ({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  padding: "16px 8px 12px 8px",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "flex-start",
  zIndex: 10,
});

export const infoCardsContainerStyles: SxProps = {
  display: "flex",
  flexDirection: "row",
  gap: "4px",
  flex: 1,
  paddingRight: "8px",
};

export const infoCardStyles: SxProps<Theme> = (theme: Theme) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  flex: 1,
  minWidth: 0,
});

export const cardLabelStyles: SxProps<Theme> = (theme: Theme) => ({
  fontSize: "10px",
  fontWeight: "400",
  color: "#FF6B6B",
  marginBottom: "2px",
  textTransform: "lowercase",
});

export const cardValueStyles: SxProps<Theme> = (theme: Theme) => ({
  fontSize: "12px",
  fontWeight: "600",
  color: theme.palette.mode === "dark" ? "white" : theme.palette.text.primary,
  lineHeight: 1.1,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  maxWidth: "100%",
});

export const timerCardStyles: SxProps<Theme> = (theme: Theme) => ({
  position: "fixed",
  top: "55px",
  right: "8px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  minWidth: "60px",
  zIndex: 1000,
});

export const circularProgressStyles: SxProps<Theme> = (theme: Theme) => ({
  color: "#4FC3F7",
  width: "50px !important",
  height: "50px !important",
});

export const timerTextStyles: SxProps<Theme> = (theme: Theme) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  fontSize: "16px",
  fontWeight: "bold",
  color: theme.palette.mode === "dark" ? "white" : theme.palette.text.primary,
  lineHeight: 1,
});

export const timerLabelSmallStyles: SxProps<Theme> = (theme: Theme) => ({
  fontSize: "8px",
  color: "#FF6B6B",
  textAlign: "center",
  marginTop: "4px",
  textTransform: "lowercase",
  lineHeight: 1,
});

export const centralContentStyles: SxProps<Theme> = (theme: Theme) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "16px",

  [theme.breakpoints.down("sm")]: {
    top: "40%",
  },
});

export const avatarContainerStyles: SxProps = {
  position: "relative",
  marginBottom: "8px",
};

export const adaptiveBotAvatarStyles: SxProps<Theme> = (theme: Theme) => ({
  width: 240,
  height: 240,
  borderRadius: "50%",
  maxWidth: "none",
  objectFit: "cover",
  objectPosition: "top",
  border:
    theme.palette.mode === "dark"
      ? "3px solid rgba(255, 255, 255, 0.3)"
      : "3px solid rgba(0, 0, 0, 0.2)",
});

export const titleStyles: SxProps<Theme> = (theme: Theme) => ({
  fontSize: "24px",
  fontWeight: "700",
  color: theme.palette.mode === "dark" ? "white" : theme.palette.text.primary,
  textAlign: "center",
  marginBottom: "4px",
});

export const subtitleStyles: SxProps<Theme> = (theme: Theme) => ({
  fontSize: "14px",
  color:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, 0.8)"
      : theme.palette.text.secondary,
  textAlign: "center",
});

export const liveSpeechStepsStyles: SxProps<Theme> = (theme: Theme) => ({
  textAlign: "center",
  fontWeight: "bold",
  color: "#d32f2f",
});

export const mobileHeaderStyles: SxProps<Theme> = (theme: Theme) => ({
  position: "absolute",
  top: 16,
  left: 16,
  right: 16,
  gap: "5px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  zIndex: 1000,

  [theme.breakpoints.up("sm")]: {
    display: "none",
  },
});

export const mobileInfoTextStyles: SxProps<Theme> = (theme: Theme) => ({
  fontSize: "12px",
  fontWeight: "600",
  color: theme.palette.mode === "dark" ? "white" : "#2c3e50",
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, 0.1)"
      : "rgba(255, 255, 255, 0.8)",
  padding: "4px 8px",
  borderRadius: "8px",
  backdropFilter: "blur(10px)",
});

export const mobileTimerStyles: SxProps<Theme> = (theme: Theme) => ({
  position: "absolute",
  top: 16,
  right: 16,
  zIndex: 1000,

  [theme.breakpoints.up("sm")]: {
    top: 16,
  },
});

export const microphoneErrorModalStyles: SxProps<Theme> = (theme: Theme) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 3,
  padding: 4,
  textAlign: "center",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: "400px",
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(30, 30, 30, 0.98)"
      : "rgba(255, 255, 255, 0.95)",
  borderRadius: "16px",
  boxShadow:
    theme.palette.mode === "dark"
      ? "0 8px 32px rgba(0,0,0,0.6)"
      : "0 8px 32px rgba(0,0,0,0.2)",
  border:
    theme.palette.mode === "dark"
      ? "1px solid rgba(255, 255, 255, 0.1)"
      : "none",
  zIndex: 1000,
});

export const retryButtonStyles: SxProps<Theme> = (theme: Theme) => ({
  backgroundColor: "#4CAF50",
  color: "#fff",
  padding: "12px 24px",
  borderRadius: "8px",
  "&:hover": {
    backgroundColor: "#45a049",
  },
});

export const closeErrorButtonStyles: SxProps<Theme> = (theme: Theme) => ({
  backgroundColor: "#ED8D81",
  color: "#fff",
  padding: "12px 24px",
  borderRadius: "8px",
  "&:hover": {
    backgroundColor: "#D87A6E",
  },
});
